import Highlighter from 'react-highlight-words';

import { QueryType } from 'store/slices/query';

import useTableCompany from './useTableCompany';

export interface TableCompanyProps {
  companyName: string;
  requester: string;
  queryType?: QueryType;
}

const HIGHLIGHT_PROPS = {
  highlightClassName: 'text-green-400 bg-transparent',
  autoEscape: true,
};

const TableCompany: React.FunctionComponent<TableCompanyProps> = function ({
  companyName,
  requester,
  queryType = 'rateRequests',
}) {
  const searchWords = useTableCompany(queryType);
  return (
    <div className="flex flex-col">
      <Highlighter
        className="text-16-20-em"
        textToHighlight={companyName}
        searchWords={searchWords}
        {...HIGHLIGHT_PROPS}
      />
      <Highlighter
        className="text-14-22 text-neutral-800"
        textToHighlight={requester}
        searchWords={searchWords}
        {...HIGHLIGHT_PROPS}
      />
    </div>
  );
};

export default TableCompany;
